import { render, staticRenderFns } from "./FormAnswerInput.vue?vue&type=template&id=381d3709&scoped=true&"
import script from "./FormAnswerInput.vue?vue&type=script&lang=js&"
export * from "./FormAnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./FormAnswerInput.vue?vue&type=style&index=0&id=381d3709&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d3709",
  null
  
)

export default component.exports